import { render, staticRenderFns } from "./SentView.vue?vue&type=template&id=37347cb5"
import script from "./SentView.vue?vue&type=script&lang=js"
export * from "./SentView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports